import { searchByKeys } from '@witmetrics/utils/arrays';
import { KEYPOINT_TYPE_ID } from '@witmetrics/utils/constants';
import type {
  DecoratedUnisonProject,
  FileUploadedContent,
} from '@witmetrics/utils';
import { currentDate } from '@witmetrics/utils/time';
import { API } from '@/api';

export const classes = {
  breadcrumbs: 'pt-0 pb-4',
  fileCollection: 'max-w-[800px]',
};

export function filterCollectionItems<
  T extends { name: string; description?: string | null },
>(items: T[] | null, searchQuery: string) {
  return searchByKeys(items || [], ['name', 'description'], searchQuery);
}

export async function createFilesKeypoint(
  project: DecoratedUnisonProject,
  fileIds: number[]
) {
  let content: FileUploadedContent = { unisonProjectId: project.id };
  if (fileIds.length === 1) content.fileId = fileIds[0];
  const keypoint = await API.Keypoints.createNewKeypoint({
    practiceId: project.practiceId,
    keypointTypeId: KEYPOINT_TYPE_ID.FILES_UPLOADED,
    startsAt: currentDate(),
    content,
  });
  return API.UnisonProjects.addKeypointToUnisonProject(project.id, keypoint.id);
}
